import {useGetTradeName, useGetTradeNameActivities} from '@/modules/products/trade-names/api'
import {EventLog, TradeName} from '@cypro/engine/schema'
import {createContext, PropsWithChildren, useContext} from 'react'

interface State {
  tradeName: TradeName
  activities?: EventLog[]
}

interface Props extends PropsWithChildren {
  tradeName: TradeName
}

const TradeNameContext = createContext<State>({} as State)

export function TradeNameProvider({children, tradeName: initialTradeName}: Props) {
  const [tradeName] = useGetTradeName(initialTradeName.id)
  const [activities] = useGetTradeNameActivities(initialTradeName.id)

  return (
    <TradeNameContext.Provider value={{tradeName: tradeName || initialTradeName, activities}}>
      {children}
    </TradeNameContext.Provider>
  )
}

export function useTradeNameContext() {
  return useContext(TradeNameContext)
}
